var _use, _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleCloudPlatform(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81 66",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-cloud-platform-icon",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "google-cloud-platform-icon",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.764 17.729h2.439l6.953-6.954.341-2.953C47.556-3.602 27.805-2.368 16.381 10.574c-3.174 3.592-5.474 7.871-6.733 12.5.773-.317 1.633-.37 2.44-.144l13.907-2.295s.706-1.172 1.076-1.1a17.35 17.35 0 0 1 23.742-1.806h-.048z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.064 23.074a31.3 31.3 0 0 0-9.441-15.223l-9.758 9.758a17.35 17.35 0 0 1 6.368 13.763v1.734a8.69 8.69 0 0 1 8.687 8.687 8.69 8.69 0 0 1-8.687 8.687H39.859l-1.734 1.758v10.421l1.734 1.734h17.374c12.476.096 22.671-9.94 22.767-22.416a22.6 22.6 0 0 0-9.936-18.901z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.46 64.282h17.374V50.375H22.46a8.65 8.65 0 0 1-3.587-.783l-2.44.759-7.002 6.954-.61 2.439c3.923 2.968 8.716 4.562 13.638 4.538z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.46 19.17C9.979 19.242-.072 29.418 0 41.899a22.58 22.58 0 0 0 8.822 17.773l10.075-10.075a8.69 8.69 0 0 1-4.341-11.492 8.69 8.69 0 0 1 11.492-4.341c1.926.869 3.467 2.415 4.341 4.341L40.463 28.03a22.54 22.54 0 0 0-18.003-8.86z",
    fill: "#fbbc05"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudPlatform);
export default __webpack_public_path__ + "static/media/google-cloud-platform.e0353f44.svg";
export { ForwardRef as ReactComponent };